import VueRouter from 'vue-router'
import Vue from 'vue'

import Layout from "@@/layout";
import store from "@@/store";

// 通过vue.use(插件)，安装插件
Vue.use(VueRouter)
// 创建路由对象
const routes = [
    {
        path: '',
        component: Layout,
        redirect: '/',
        children:[
            {
                path: '/',
                name: "index",
                component: () => import('@@/view/homePage/index'),
                meta: {
                    title: '鄂尔多斯市国有企业阳光采购平台'
                }
            },
            {
                path: 'newsDetail',
                name: "newsDetail",
                component: () => import('@@/view/homePage/newsDetail/index'),
                meta: {
                    title: '新闻公告详情'
                }
            },
            {
                path: 'transactionInformation',
                name: "transactionInformation",
                component: () => import('@@/view/transactionInformation/index'),
                meta: {
                    title: '交易信息'
                }
            },
            {
                path: 'transactionInformationDetail',
                name: "transactionInformationDetail",
                component: () => import('@@/view/transactionInformation/detail/index'),
                meta: {
                    title: '交易信息详情'
                }
            },
            {
                path: 'helpCenter',
                name: "helpCenter",
                component: () => import('@@/view/helpCenter/index'),
                meta: {
                    title: '帮助中心'
                }
            },
            {
                path: 'helpCenterDetail',
                name: "helpCenterDetail",
                component: () => import('@@/view/helpCenter/detail/index'),
                meta: {
                    title: '帮助中心'
                }
            },
            {
                path: 'downloadCenter',
                name: "downloadCenter",
                component: () => import('@@/view/downloadCenter/index'),
                meta: {
                    title: '下载中心'
                }
            },
            {
                path: 'aboutUs',
                name: "aboutUs",
                component: () => import('@@/view/aboutUs/index'),
                meta: {
                    title: '关于我们'
                }
            }
        ]
    }
]
const router = new VueRouter({
    // 配置URL和组价直接的映射关系
    routes,
    base: "",
    // history模式 
    mode: 'history'
})
// 将router对象传入到vue实例中
export default router

router.beforeEach((to, from, next) => {
    // console.log('meta', to.meta.title)
    if (!store.state.platformInfo.id)  store.dispatch('getPlatformInfo')
    if(to.meta) {
        if (to.meta.title) {
            document.title = to.meta.title
        }
    }
    next()
})